import React, { useState } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { ExpandHeader, ToolCallWrapper } from '../shared/ToolCallComponents';
import Text from '../../../TextComponents/Text/Text';

interface PdfToolProps {
    item: any;
    isInProgress: boolean;
}

export const CreatePdf: React.FC<PdfToolProps> = ({ item, isInProgress }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const stage = isInProgress ? {
        current: !item.status ? 1 :
                item.status.message === "converting" ? 2 :
                item.status.message === "uploading" ? 3 : 4,
        total: 4,
        label: !item.status ? "writing" : item.status.message
    } : undefined;

    return (
        <ToolCallWrapper>
            <ExpandHeader
                icon={<FaFilePdf className="mr-2 text-neutral-500 dark:text-neutral-400" size={14}/>}
                title="Creating PDF"
                isExpanded={isExpanded}
                isInProgress={isInProgress}
                onClick={() => setIsExpanded(prev => !prev)}
                stage={stage}
            />
            {isExpanded && item.docUrl && (
                <div className="ml-2 mt-2">
                    <Text item={{ text: `[PDF File](${item.docUrl})` }} index={0} />
                </div>
            )}
        </ToolCallWrapper>
    );
};